module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-client-credit-note"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns p-3"
  }, [_c('RefundableRecords', {
    staticClass: "text-center",
    attrs: {
      "data-loader": _vm.dataLoader,
      "selected": _vm.selected
    },
    on: {
      "select": _vm.mapRecords
    }
  }), _vm._l((_vm.body.records), function(record, index) {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('BackofficeWalletRecord', {
      attrs: {
        "item": _vm.findRecord(record.id),
        "type": "multi-wallet"
      }
    })], 1), _c('div', {
      staticClass: "columns"
    }, [_c('label', [_vm._v("Type"), (_vm.body.records[index].type === 'EXACT_AMOUNT') ? _c('div', {
      staticClass: "help-text"
    }, [_vm._v("Amount should have be billed")]) : _vm._e(), (_vm.body.records[index].type === 'DISCOUNT') ? _c('div', {
      staticClass: "help-text"
    }, [_vm._v("Discount paid amount")]) : _vm._e(), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.body.records[index].type),
        expression: "body.records[index].type"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.body.records[index], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "EXACT_AMOUNT"
      }
    }, [_vm._v("Exact amount")]), _c('option', {
      attrs: {
        "value": "DISCOUNT"
      }
    }, [_vm._v("Discount")])])]), _c('label', [_vm._v("Amount vat included"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.body.records[index].amount),
        expression: "body.records[index].amount"
      }],
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (_vm.body.records[index].amount)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.body.records[index], "amount", $event.target.value)
        }, function($event) {
          return _vm.checkValue($event, record.id)
        }]
      }
    })]), _c('div', {
      staticClass: "row text-center"
    }, _vm._l((_vm.getRecordAmount(_vm.body.records[index])), function(value, key) {
      return _c('div', {
        staticClass: "column"
      }, [_c('label', [_vm._v(_vm._s(key.replace("_", " ")))]), _c('h2', [_vm._v(_vm._s(_vm.$priceWithcurrency(value)))])])
    }), 0), (_vm.findRecord(record.id).invoice.document_total === 0) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(0, true)]) : _vm._e()])]), _c('hr')]
  }), (Object.keys(_vm.body.records).length) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column large-4"
  }, [_c('label', [_vm._v("Reason"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reason),
      expression: "body.reason"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "reason", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Emit as PROFORMA"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.emit_as_proforma),
      expression: "body.emit_as_proforma"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.emit_as_proforma) ? _vm._i(_vm.body.emit_as_proforma, null) > -1 : (_vm.body.emit_as_proforma)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.body.emit_as_proforma,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "emit_as_proforma", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "emit_as_proforma", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "emit_as_proforma", $$c)
        }
      }, function($event) {
        _vm.body.emit_as_proforma ? _vm.body.refund_on_gateway = false : _vm.body.emit_as_proforma
      }]
    }
  })]), _c('label', [_vm._v("Refund on gateway"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.refund_on_gateway),
      expression: "body.refund_on_gateway"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.body.emit_as_proforma
    },
    domProps: {
      "checked": Array.isArray(_vm.body.refund_on_gateway) ? _vm._i(_vm.body.refund_on_gateway, null) > -1 : (_vm.body.refund_on_gateway)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.refund_on_gateway,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "refund_on_gateway", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "refund_on_gateway", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "refund_on_gateway", $$c)
        }
      }
    }
  })])]), _c('div', {
    staticClass: "column text-right mr-3"
  }, [_c('h2', [_vm._v("Total amount: " + _vm._s(_vm.$priceWithcurrency(_vm.getSummary.toFixed(2))))]), _c('ActionButton', {
    attrs: {
      "action": _vm.emit,
      "confirm": true
    }
  }, [_vm._v("Emit "), (_vm.body.emit_as_proforma) ? _c('span', [_vm._v("as Proforma")]) : _c('span', [_vm._v("as Credit note")])])], 1)])] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Can be only refunded as PAID credit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a5d20b2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientCreditNote.vue
// module id = 2304
// module chunks = 1